import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const unPinDeviceFromDashboard = async (id: number): Promise<boolean> =>
  axios.delete(`/dashwidget/unpinunit?id=${id}`).then((res) => res?.data?.result)

type Props = {
  id: number
}

export const useUnPinDeviceFromDashboard = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['unPinDeviceFromDashboard'],
    mutationFn: ({ id }: Props) => unPinDeviceFromDashboard(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Un-pinned from dashboard.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to un-pin from dashboard.')
      }
    },
    throwOnError: false
  })
